

export default (state = {}, action)=> {

  switch (action.type) {

  case 'MARK_AS_DRAFT': {
    return {
      ...state,
      isDraft: true
    };
  }

  case 'MARK_AS_PUBLISHED': {
    return {
      ...state,
      published_version: state.published_version + 1,
      isDraft: false
    };
  }
  
  case 'MARK_AS_REQUESTED_APPROVAL': {
    return {
      ...state,
      approval_request_message: action.approvalRequestMessage,
      approval_pending: true
    };
  }

  case 'SET_PAGE_NAME': {
    return {
      ...state,
      unpublishedName: action.pageName
    };
  }

  case 'UPDATE_PAGE_FROM_SERVER': {
    return {
      ...state,
      ...action.data
    };

  }

  case 'SET_LAST_EDITED_META_FOR_PAGE':
    return { 
      ...state,
      lastEditedAt: action.lastEditedAt,
      lastEditedByUserId: action.lastEditedByUserId
    };

  default: {
    return state;
  }

  }
};

export const getPageName = (state)=>
  state.unpublishedName;

export const getIsDraft = (state)=> 
  state.isDraft;
  
export const getPageHasApprovalPending = (state)=> 
  state.approval_pending;

export const getPageAllowsNewLinks = (state)=>
  state.allow_new_links;

export const getPageIsTemplate = (state)=>
  state.is_template;

export const getPageIsSuper = (state)=>
  state.is_super;

export const getPageHasEverBeenPublished = (state)=>
  state.is_published;

export const getPageCanonicalUrl = (state)=>
  state.canonical_url;

export const getPageMostRecentPublishedVersion = (state)=>
  state.published_version;

export const getPageId = (state)=>
  state.id;

export const getPageUrlId = (state)=>
  state.urlId;

export const getLastEditedByUserId = (state)=>
  state.lastEditedByUserId;

export const getLastEditedAt = (state)=>
  state.lastEditedAt;
